export const VIPCircleActionTypes = {
    CREATE_VIP_CIRCLE_REQUEST: "@@VIPCircle/CREATE_VIP_CIRCLE_REQUEST",
    CREATE_VIP_CIRCLE_SUCCESS: "@@VIPCircle/CREATE_VIP_CIRCLE_SUCCESS",
    CREATE_VIP_CIRCLE_FAILURE: "@@VIPCircle/CREATE_VIP_CIRCLE_FAILURE",

    UPDATE_VIP_CIRCLE_REQUEST: "@@VIPCircle/UPDATE_VIP_CIRCLE_REQUEST",
    UPDATE_VIP_CIRCLE_SUCCESS: "@@VIPCircle/UPDATE_VIP_CIRCLE_SUCCESS",
    UPDATE_VIP_CIRCLE_FAILURE: "@@VIPCircle/UPDATE_VIP_CIRCLE_FAILURE",

    CANCEL_VIP_CIRCLE_REQUEST: "@@VIPCircle/CANCEL_VIP_CIRCLE_REQUEST",
    CANCEL_VIP_CIRCLE_SUCCESS: "@@VIPCircle/CANCEL_VIP_CIRCLE_SUCCESS",
    CANCEL_VIP_CIRCLE_FAILURE: "@@VIPCircle/CANCEL_VIP_CIRCLE_FAILURE",

    FETCH_VIP_SUBSCRIPTION_REQUEST:
        "@@VIPCircle/FETCH_VIP_SUBSCRIPTION_REQUEST",
    FETCH_VIP_SUBSCRIPTION_SUCCESS:
        "@@VIPCircle/FETCH_VIP_SUBSCRIPTION_SUCCESS",
    FETCH_VIP_SUBSCRIPTION_FAILURE:
        "@@VIPCircle/FETCH_VIP_SUBSCRIPTION_FAILURE",

    FETCH_VIP_CIRCLE_REQUEST: "@@VIPCircle/FETCH_VIP_CIRCLE_REQUEST",
    FETCH_VIP_CIRCLE_SUCCESS: "@@VIPCircle/FETCH_VIP_CIRCLE_SUCCESS",
    FETCH_VIP_CIRCLE_FAILURE: "@@VIPCircle/FETCH_VIP_CIRCLE_FAILURE",

    FETCH_OTHER_VIP_CIRCLE_REQUEST:
        "@@VIPCircle/FETCH_OTHER_VIP_CIRCLE_REQUEST",
    FETCH_OTHER_VIP_CIRCLE_SUCCESS:
        "@@VIPCircle/FETCH_OTHER_VIP_CIRCLE_SUCCESS",
    FETCH_OTHER_VIP_CIRCLE_FAILURE:
        "@@VIPCircle/FETCH_OTHER_VIP_CIRCLE_FAILURE",

    SEND_VIP_CIRCLE_REQUEST: "@@VIPCircle/SEND_VIP_CIRCLE_REQUEST",
    SEND_VIP_CIRCLE_SUCCESS: "@@VIPCircle/SEND_VIP_CIRCLE_SUCCESS",
    SEND_VIP_CIRCLE_FAILURE: "@@VIPCircle/SEND_VIP_CIRCLE_FAILURE",

    UPSERT_VIP_CIRCLE_REQUEST: "@@VIPCircle/UPSERT_VIP_CIRCLE_REQUEST",
    UPSERT_VIP_CIRCLE_SUCCESS: "@@VIPCircle/UPSERT_VIP_CIRCLE_SUCCESS",
    UPSERT_VIP_CIRCLE_FAILURE: "@@VIPCircle/UPSERT_VIP_CIRCLE_FAILURE",

    DELETE_VIP_CIRCLE_REQUEST: "@@VIPCircle/DELETE_VIP_CIRCLE_REQUEST",
    DELETE_VIP_CIRCLE_SUCCESS: "@@VIPCircle/DELETE_VIP_CIRCLE_SUCCESS",
    DELETE_VIP_CIRCLE_FAILURE: "@@VIPCircle/DELETE_VIP_CIRCLE_FAILURE",

    EDIT_VIP_CIRCLE_REQUEST: "@@VIPCircle/EDIT_VIP_CIRCLE_REQUEST",
};
